import React, { Component, PropTypes } from 'react';
import Image from 'components/Image';

/**
 * Class representing a sponsored image unit, to display which entity is sponsoring the given content
 */
class SponsorUnit extends Component {
  static propTypes = {
    sponsorImageUri: PropTypes.string,
    sponsorLink: PropTypes.string
  }

  static defaultProps = {
    sponsorImageUri: "",
    sponsorLink: ""
  }

  render() {
    const { sponsorImageUri, sponsorLink } = this.props;

    if (!sponsorImageUri) return null;

    return (
      <div className="SponsorUnit">
        <a className="SponsorUnit-sponsoredLink" href={sponsorLink} target="_blank" rel="noopener noreferrer">
          <Image imageClassNames="SponsorUnit-image" width="120" src={sponsorImageUri} />
        </a>
      </div>
    );
  }

}

export default SponsorUnit;



// WEBPACK FOOTER //
// ./app/components/ads/SponsorUnit.js